<div class="filters_view_bg" [hidden]="!searchDropDownToggle" (click)="searchDropDownToggle = false"></div>
<div class="search-path">
    <button class="btn btn-primary" (click)="searchDropDownToggle = !searchDropDownToggle">
        Filter
    </button>
    <div class="searchDropdown" [hidden]="!searchDropDownToggle" style="z-index: 51;">
        
      <form [formGroup]="searchForm" autocomplete="off" (ngSubmit)="onSubmit()">
           

            <!-- <div *ngIf="showCustomer === true" class="dropdownFields">
                <label>Customer</label>
                <ng-select [multiple]="false"
                    formControlName="ACCOUNT_ID_IN" appendTo="body" placeholder="">
                    <ng-option *ngFor="let item of accountLists" [value]="item.id">{{item?.accountName}}</ng-option>
                </ng-select>
            </div> -->

         <!-- Catagory -->
            <div *ngIf="showCategory === true" class="dropdownFields multi-select-height">
                <label>Category</label>
                <ng-select [multiple]="true" formControlName="CATEGORY_IN"  placeholder="Select category" appendTo="body">
                  <ng-option *ngFor="let category of category" [value]="category.id">
                    {{ category.categoryDescription }}
                  </ng-option>
                </ng-select>
              </div>
         
            <!-- USER NAME -->
            <!-- <div *ngIf="showUserName === true" class="dropdownFields">
                <label>User Name</label>
                <input type="text" class="form-control" formControlName="USER_NAME" placeholder="">
            </div> -->

           
             <!-- USER NAME -->
             <div *ngIf="showVendorCode === true" class="dropdownFields">
                <label>Vendor Code</label>
                <input type="text" class="form-control" formControlName="VENDOR_CODE" placeholder="">
            </div>
         
        
            <!-- USER EMAIL -->
            <div *ngIf="showUserEmail === true" class="dropdownFields">
                <label>Email</label>
                <input type="text" class="form-control" formControlName="EMAIL_IN">
            </div>
            <!-- USER Mobile No -->
            <div *ngIf="showUserMobileNo === true" class="dropdownFields">
                <label>Mobile No.</label>
                <input type="text" class="form-control" formControlName="MOBILE_NUMBER">
            </div>
        
           
            <!-- ROLE MANAGEMENT -->
            <!-- <div *ngIf="showRoleName === true" class="dropdownFields multi-select-height">
                <label>Employee Position</label>
                <ng-select [multiple]="true" formControlName="USER_ROLE"   appendTo="body">
                  <ng-template ng-header-tmp>
                    <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1"
                                (click)="onSelectAll('USER_ROLE',roleList)">Select All</button>
                        <button class="btn ng-select-btn btn reset-btn btn-cancel ms-1"
                                (click)="onClearAll('USER_ROLE')">Clear All</button>
                    </div>
                  </ng-template>
                  <ng-option *ngFor="let item of roleList" [value]="item.id">
                    {{ item.roleDescription }}
                  </ng-option>
                </ng-select>
              </div> -->
         
          
           
          
           
            
            <!-- QUICKCODE NAME -->
              <div *ngIf="showQuickCodeName === true" class="dropdownFields">
                <label>Name</label>
                <input type="text" class="form-control" formControlName="NAME_IN">
            </div>

            <div *ngIf="showDateFilter" class="dropdownFields" [ngClass]="{disabled: searchForm.controls['DUMMY_FILTER_TWO'].value}">
              <label>Created At</label>
              <select class="form-control" name="createdAt" formControlName="DUMMY_FILTER_THREE" [(ngModel)]="selectedOption" (change)="onOptionChange($event)">
                <option value="">All</option>
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="last-week">Last Week</option>
                <option value="last-month">Last Month</option>
                <option value="current-month">Current Month</option>
                <option value="custom">Custom Date Range</option>
              </select>
              <div class="custom-wrapper" *ngIf="showCustomDateRange">
                <div>
                  <label for="fromDate">From Date:</label>
                  <input class="form-control" name="fromDate" formControlName="CREATED_FROM_DATE" type="datetime-local"/>
                </div>
                <div>
                  <label for="toDate">To Date:</label>
                  <input class="form-control"  name="toDate" formControlName="CREATED_TO_DATE" type="datetime-local" />
                </div>
              </div>
            </div>
          
          

         <!-- Status Dropdown (Visible based on Input) -->
            <!-- <div *ngIf="orderStatus === true" class="dropdownFields">
                <label>Status</label>
                <ng-select formControlName="STATUS_IN" placeholder="Select status" appendTo="body">
                    <ng-option *ngFor="let item of statusList" [value]="item.name">
                    {{ item.name }}
                  </ng-option>
                </ng-select>
            </div> -->

            <!-- <div class="dropdownFields" *ngIf="DateofPlacement == true">
              <label>Select Date Range</label>
              <p-calendar formControlName="DATE_RANGE" selectionMode="range" appendTo="body" [readonlyInput]="true"  [maxDate]="today" (onSelect)="selectRange($event)"></p-calendar>
          </div>  -->










          <!-- Truck Fleet -->
          
            <!-- truckNumber NAME -->
              <div *ngIf="truckNumber === true" class="dropdownFields">
                <label>Truck Number</label>
                <input type="text" class="form-control" formControlName="TRUCK_NUMBER_IN">
            </div>
            <!-- brand Dropdown (Visible based on Input) -->
            <div *ngIf="truckBrand === true" class="dropdownFields">
                <label>Brand</label>
                <ng-select formControlName="BRAND_ID_IN" placeholder="Select Brand" appendTo="body">
                    <ng-option *ngFor="let item of brandList" [value]="item.id">
                    {{ item.name }}
                  </ng-option>
                </ng-select>
            </div>
             <!-- truckModel NAME -->
              <div *ngIf="SERIALNUMBERIN === true" class="dropdownFields">
                <label>{{billNumber ? 'Bill Number': 'Serial Number'}}</label>
                <input type="text" class="form-control" formControlName="SERIAL_NUMBER_IN">
            </div>
               <div *ngIf="productCode === true" class="dropdownFields">
                <label>Product Code</label>
                <input type="text" class="form-control" formControlName="PRODUCT_CODE_IN">
            </div>
            

             <!-- truckModel NAME -->
              <!-- <div *ngIf="truckNumber === true" class="dropdownFields">
                <label>Truck Model</label>
                <input type="text" class="form-control" formControlName="MODEL_NUMBER">
            </div> -->

             <!-- pollutionNumber NAME -->
              <div *ngIf="pollutionNumber === true" class="dropdownFields">
                <label>Puc Number</label>
                <input type="text" class="form-control" formControlName="PUC_IN">
            </div>

             <!-- insuranceNumber NAME -->
              <div *ngIf="insuranceNumber === true" class="dropdownFields">
                <label>Insurance Number</label>
                <input type="text" class="form-control" formControlName="INSURANCE_NUMBER_IN">
            </div>

            <div *ngIf="showVendor === true" class="dropdownFields">
                <label>Vendor</label>
                <ng-select formControlName="VENDOR_ID_IN" placeholder="Select Vendor" appendTo="body">
                    <ng-option *ngFor="let item of vendorsList" [value]="item.id">
                    {{ item.vendorName }}
                  </ng-option>
                </ng-select>
            </div>
            <div *ngIf="statusFilter === true" class="dropdownFields">
                <label>Status</label>
                <ng-select formControlName="STATUS_IN" placeholder="Select status" appendTo="body">
                    <ng-option *ngFor="let item of statusList" [value]="item.value">
                    {{ item.label }}
                  </ng-option>
                </ng-select>
            </div>



          <div *ngIf="insurerName === true" class="dropdownFields">
            <label>Insurer Name</label>
            <input type="text" class="form-control" formControlName="NAME_IN">
          </div>
          <div *ngIf="getNumber === true" class="dropdownFields">
            <label>GST Number</label>
            <input type="text" class="form-control" formControlName="GST_NUMBER_IN">
          </div>
          <div *ngIf="panNumber === true" class="dropdownFields">
            <label>Pan Number</label>
            <input type="text" class="form-control" formControlName="PAN_NUMBER_IN">
          </div>
          <div *ngIf="licenceNumber === true" class="dropdownFields">
            <label>Licence Number</label>
            <input type="text" class="form-control" formControlName="LICENCE_NUMBER_IN">
          </div>



          <div *ngIf="repairBillNumber === true" class="dropdownFields">
            <label>Repair BillNumber</label>
            <input type="text" class="form-control" formControlName="BILL_NUMBER_IN">
          </div>
          <div *ngIf="repairAddress === true" class="dropdownFields">
            <label>Repair Address</label>
            <input type="text" class="form-control" formControlName="LOCATION_NAME_IN">
          </div>
          <div *ngIf="repairAmount === true" class="dropdownFields">
            <label>Repair Amount</label>
            <input type="text" class="form-control" formControlName="AMOUNT_IN">
          </div>

          <div *ngIf="modelName === true" class="dropdownFields">
            <label>Model Name</label>
            <input type="text" class="form-control" formControlName="NAME_IN">
          </div>

          <div *ngIf="modelNumber === true" class="dropdownFields">
            <label>Model Number</label>
            <input type="text" class="form-control" formControlName="MODEL_NUMBER_IN">
          </div>
          
          
            <!-- Action Buttons -->
            <div class="advance-icon flex-row-reverse flex-end justify-content-start">
                <button class="btn btn-primary ms-1" type="submit">Search</button>
                <button class="btn reset-btn btn-cancel" type="button" (click)="onReset()">Reset</button>
            </div>


           
        </form>
    </div>
</div>